export const TENET_HELP_LINK = 'https://help.tenet.ky';
export const TERMS_OF_USE_LINK = 'https://tenet.ky/legal/terms';
export const PRIVACY_POLICY_LINK = 'https://tenet.ky/legal/privacy';
